module.exports = __webpack_public_path__ + "img/gmail.0c94f73b.png";